import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '../../../typography';
import { Icon } from '../../../icon';
import { StackPanel } from '../../../stack-panel';
import { selectThemeSemantics } from '../../../../styling';

const Label = styled(Typography.XSmall)`
    color: ${({ theme: { menu: { replaceMenu: { colors: { backButton } } } } }) => backButton.foregroundColor}
`;

const BackButtonBase = React.memo((props: { className?: string, text: string, onNavigateBackToParent(): void }) => {
    const { className, onNavigateBackToParent, text } = props;
    return (
        <StackPanel className={className} alignment="center" gap="10" onClick={onNavigateBackToParent}>
            <Icon iconName="ap-arrow-right.outline" iconSize="12" />
            <Label>{text}</Label>
        </StackPanel>
    );
});

BackButtonBase.displayName = 'BackButtonBase';

export const BackButton = styled(BackButtonBase).attrs(({
    className: String('ap-replacemenu-backButton')
}))`
    cursor: default;
    margin: ${selectThemeSemantics(({ gap }) => `${gap.l} ${gap.xl}`)};
    justify-content: flex-end;
    box-sizing: border-box;

    ${Icon} {
        transform: rotate(180deg);
        background-color: ${({ theme: { menu: { replaceMenu: { colors: { backButton } } } } }) => backButton.backgroundColor};
        fill: ${({ theme: { menu: { replaceMenu: { colors: { backButton } } } } }) => backButton.iconColor};
        border-radius: ${({ theme: { menu: { replaceMenu: { composites } } } }) => composites.backIconBorderRadius};
        padding: ${selectThemeSemantics(({ gap }) => gap.xs)};
    }
`;

BackButton.displayName = 'BackButton';
